import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';

// Importar directamente el PDF
import PDF from "../../documentos/Nueva APP Stupid Comedy 2.pdf";

const PDFViewerPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white">
      <Helmet>
        <title>Visualizador de PDF - Stupid Comedy</title>
        <meta name="description" content="Visualiza la información de la aplicación Stupid Comedy" />
      </Helmet>

      <main className="container mx-auto px-4 py-8">
        <motion.h1 
          className="text-3xl md:text-4xl font-bold mb-6 text-center bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-indigo-500"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Documentación Stupid Comedy
        </motion.h1>

        <div className="bg-gray-800 bg-opacity-70 rounded-t-xl p-4 mb-1 flex justify-end">
          {/* Descarga */}
          <a 
            href={PDF} 
            download="Nueva APP Stupid Comedy.pdf"
            className="px-3 py-1 bg-indigo-700 hover:bg-indigo-600 rounded-md flex items-center space-x-1 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            <span>Descargar</span>
          </a>
        </div>

        {/* Contenedor del PDF con iframe */}
        <div className="bg-gray-800 bg-opacity-30 rounded-b-xl p-4 overflow-hidden">
          <iframe
            src={PDF}
            title="Nueva APP Stupid Comedy"
            className="w-full h-[700px] rounded-lg border-0"
            style={{ backgroundColor: 'white' }}
          />
        </div>

        {/* Información del archivo */}
        <div className="mt-6 text-center text-gray-400 text-sm">
          <p>
            Archivo: <span className="text-blue-400">Nueva APP Stupid Comedy.pdf</span>
          </p>
        </div>
      </main>
    </div>
  );
};

export default PDFViewerPage;